import { useSelector } from "react-redux";
import {
    Navigate,
    Outlet,
    useLocation
} from "react-router-dom";
// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.


const ProtectedRoute = () => {
    const user = useSelector(state => state.auth.user);
    const location = useLocation();

    // If user is not authenticated, redirect to home page but save the attempted URL
    if (!user) {
        return <Navigate to="/" state={{ from: location.pathname }} replace />;
    }

    return <Outlet />;
}

export default ProtectedRoute;